// removed by extract-text-webpack-plugin
module.exports = {"theme":"#4e55c1"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/element-variables.scss
// module id = +hAf
// module chunks = 97